"use client";

import { quoteThemeColorStyles, quoteThemeCssVars } from "../quote-theme/quote-theme-css-vars";
import { CreditCard } from "lucide-react";
import { useHolidayQuoteBrand } from "../contexts/use-holiday-quote-brand";

interface QuoteDepositPayButtonProps {
  quoteId?: string;
  pricingBlockId?: string;
  depositAmount: number;
  currency: string;
  primaryColor?: string;
  disabled?: boolean;
}

export function QuoteDepositPayButton({
  primaryColor = "#3B82F6",
  disabled = false,
}: QuoteDepositPayButtonProps) {
  const { isAdminMode } = useHolidayQuoteBrand();

  return (
    <button
      type="button"
      disabled={disabled || isAdminMode}
      className="w-full py-3 sm:py-4 px-4 rounded-xl text-white text-sm sm:text-base font-semibold transition-all duration-200 hover:scale-[1.01] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
      style={quoteThemeColorStyles.primaryBg}
    >
      <span className="flex items-center justify-center gap-2">
        <CreditCard className="h-4 w-4" />
        Make a deposit now
        {isAdminMode ? " (preview)" : ""}
      </span>
    </button>
  );
}
